module.exports = __webpack_public_path__ + "static/media/solar-panel-charge-thin.d85103a6.svg";